export default "__VITE_ASSET__ChqtXT4V__"